import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: React.ReactNode;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, ...props }, ref) => (
    <label className={cn("flex cursor-pointer items-center gap-2 text-sm text-foreground/85", className)}>
      <span className="relative flex h-4 w-4 items-center justify-center">
        <input
          ref={ref}
          type="checkbox"
          className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-border bg-input transition-colors checked:border-accent checked:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30"
          {...props}
        />
        <Check className="pointer-events-none absolute h-3 w-3 stroke-[3] text-accent-foreground opacity-0 peer-checked:opacity-100" />
      </span>
      {label && <span>{label}</span>}
    </label>
  )
);
Checkbox.displayName = "Checkbox";
